import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://taskapi.demovt360.xyz/sst/src/api', // API base URL
  timeout: 10000, // 10 seconds ka timeout
  headers: {
    'Accept': 'application/json',
  },
});
// https://taskapi.demovt360.xyz/
// Request Interceptor (Agar authentication token add karna ho)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Token ko storage se le raha hai
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Agar form-data bhejna ho toh headers change karein
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    } else {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor (Errors ko handle karne ke liye)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error('API Error:', error.response.data);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
